export enum EStrategyType {
    LaborLaw = 1,
    PublicHealthLaw,
    FDX
}